import React, { Component, Fragment } from 'react';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import {
  addQuery,
  changeInFieldInclude,
  createSelectOptionsForField,
  removeQuery,
  updateQuery,
  compressConditions,
  processQueryData,
} from './query-util';
import { primaryQueries } from './query-constant';
import CustomSelect from '../../../home/collections/CustomSelect';
import EditQueryCondition from './EditQueryCondition';
export default class EditQueryFilter extends Component {
  static propTypes = {
    filter: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    updateQueryFilter: PropTypes.func.isRequired,
    showQuery: PropTypes.func.isRequired,
    disableUpdateQueryFilter: PropTypes.func.isRequired,
  };

  state = {
    primaryQuery: {
      label: this.props.filter.finder,
      value: this.props.filter.finder,
    },
    selectedIncludeField: this.props.filter.fieldsInclude.map((field) => {
      if (field === '*') {
        return { label: 'ALL', value: 'ALL' };
      } else {
        return { label: field, value: field };
      }
    }),
    selectedExcludeField: this.props.filter.fieldsExclude.map((field) => {
      return { label: field, value: field };
    }),
    conditions: this.props.filter.conditions.map((condition, index) => {
      condition.id = index + 1;
      return condition;
    }),
    isPrivate: this.props.filter.isPrivate,
  };

  addQueryInCondition = () => {
    const conditions = addQuery(this.state.conditions);
    this.setState({ conditions });
  };

  removeQueryFromCondition = (id) => {
    const conditions = removeQuery(this.state.conditions, id);
    this.setState({ conditions });
  };

  saveQuery = (id, conditionObj) => {
    const conditions = updateQuery(this.state.conditions, id, conditionObj);
    this.setState({ conditions });
  };

  handleChange = (name, value) => {
    const updatedValue = changeInFieldInclude(name, value);
    this.setState({ [name]: updatedValue });
  };

  handleSubmit = (values, setSubmitting, resetForm) => {
    const conditionData = compressConditions(this.state.conditions);
    const queryData = processQueryData(values, conditionData);
    const { projectId, collection, filter, updateQueryFilter, version } = this.props;
    queryData.uuid = filter.uuid;
    const finalObject = {
      filterUuid: filter.uuid,
      projectId,
      collectionUuid: collection.uuid,
      data: queryData,
      version,
    };

    setSubmitting(false);
    resetForm();
    updateQueryFilter(finalObject);
  };

  renderExcludeFieldSelect = (options, setFieldValue, setFieldTouched) => {
    const { selectedIncludeField } = this.state;
    if (selectedIncludeField) {
      const checkAllExist = selectedIncludeField[0];
      if (checkAllExist.value === 'ALL') {
        return (
          <div className="form-group">
            <label>Exclude*</label>
            <CustomSelect
              name="selectedExcludeField"
              isMulti={true}
              value={this.state.selectedExcludeField}
              options={options}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              onChangeValue={this.handleChange}
            />
            <ErrorMessage name="selectedExcludeField">
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
          </div>
        );
      }
    }
  };

  createConditionField = (setFieldValue, setFieldTouched) => {
    const { collection } = this.props;
    const { conditions } = this.state;
    let collectionFields = createSelectOptionsForField(collection.fields);
    return conditions.map((condition) => (
      <div className="row p-2" key={condition.id}>
        <EditQueryCondition
          fieldOptions={collectionFields}
          fields={collection.fields}
          constants={collection.constants}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          condition={condition}
          removeQuery={this.removeQueryFromCondition}
          saveQuery={this.saveQuery}
        />
      </div>
    ));
  };

  createQuerySelector = (setFieldValue, setFieldTouched) => {
    let { primaryQuery } = this.state;
    if (!primaryQuery) {
      return '';
    }
    primaryQuery = primaryQuery.value;
    if (primaryQuery === 'FIND' || primaryQuery === 'FIND_ALL') {
      const { collection } = this.props;
      let collectionFields = createSelectOptionsForField(collection.fields);
      const includeCollectionFields = [{ value: 'ALL', label: 'ALL' }, ...collectionFields];
      return (
        <Fragment>
          <div className="form-group">
            <label>Include*</label>
            <CustomSelect
              name="selectedIncludeField"
              isMulti={true}
              value={this.state.selectedIncludeField}
              options={includeCollectionFields}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              onChangeValue={this.handleChange}
            />
            <ErrorMessage name="selectedIncludeField">
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
          </div>
          {this.renderExcludeFieldSelect(collectionFields, setFieldValue, setFieldTouched)}
        </Fragment>
      );
    } else {
      return '';
    }
  };

  render() {
    const { showQuery, filter, disableUpdateQueryFilter } = this.props;
    return (
      <div className="col-12">
        <Formik
          initialValues={{
            name: filter.name,
            primaryQuery: { label: filter.finder, value: filter.finder },
            selectedIncludeField: '',
            selectedExcludeField: '',
            isPrivate: filter.isPrivate,
          }}
          validationSchema={Yup.object().shape({
            primaryQuery: Yup.string().required("Query can't be blank"),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values, setSubmitting, resetForm);
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
            return (
              <Form>
                <div className="row">
                  <div className="col-8">{showQuery(filter)}</div>
                  <div className="col-4">
                    <button type="submit" className="btn btn-theme-submit btn-sm">
                      <i className="fa fa-save"></i> Update
                    </button>
                    &nbsp;&nbsp;
                    <button
                      className="btn btn-sm btn-theme-cancel"
                      onClick={disableUpdateQueryFilter}
                    >
                      <i className="fa fa-remove"></i> Cancel
                    </button>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Name*</label>
                      <Field
                        type="text"
                        name="name"
                        className="form-control form-control-sm"
                        placeholder="Name"
                      />
                      <ErrorMessage name="name">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>

                    <div className="form-group">
                      <Field type="checkbox" name="isPrivate" /> &nbsp;&nbsp;
                      <label>Is Private</label>
                      <ErrorMessage name="isPrivate">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>

                    <div className="form-group">
                      <label>Query*</label>
                      <CustomSelect
                        name="primaryQuery"
                        isMulti={false}
                        value={this.state.primaryQuery}
                        options={primaryQueries}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        onChangeValue={this.handleChange}
                      />
                      <small className="field-detail">Selector</small>
                      <ErrorMessage name="primaryQuery">
                        {(msg) => <p className="pl-0 ml-5 mt-5 text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                    {this.createQuerySelector(setFieldValue, setFieldTouched)}
                    <hr />
                    <div className="row">
                      <div className="col-6 text-left">Condition</div>
                      <div className="col-6 text-right">
                        <button
                          type="button"
                          className="btn btn-theme-submit btn-sm"
                          onClick={this.addQueryInCondition}
                        >
                          <i className="fa fa-plus" /> Add
                        </button>
                      </div>
                    </div>
                    <hr />
                    {this.createConditionField(setFieldValue, setFieldTouched)}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  }
}
